import React, { useState, useMemo } from 'react';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './Filter.css';

const Filter = ({ devices, raspberries, onFilterChange }) => {
  const [filters, setFilters] = useState({
    device: null,
    raspberry: null,
    status: null,
    dateRange: [null, null],
    timeRange: { start: '', end: '' }
  });

  const [showCalendar, setShowCalendar] = useState(false);

  const statusOptions = [
    { value: 'OK', label: 'OK' },
    { value: 'KO', label: 'KO' },
  ];

  const uniqueRaspberries = useMemo(() => {
    return raspberries.length > 0 
      ? [...new Set(raspberries)].map(id => ({ label: id, value: id }))
      : [];
  }, [raspberries]);

  const handleFilterChange = (type, value) => {
    const newFilters = {
      ...filters,
      [type]: value
    };
    
    setFilters(newFilters);
    
    // Prepare data for parent component
    const parentFilters = {
      device: newFilters.device?.value || null,
      raspberry: newFilters.raspberry?.value || null,
      status: newFilters.status?.value || null,
      date: newFilters.dateRange,
      timeStart: newFilters.timeRange.start,
      timeEnd: newFilters.timeRange.end,
    };
    
    onFilterChange(parentFilters);
  };

  const handleClearFilter = (type) => {
    const resetValue = type === 'dateRange' ? [null, null] : 
                      type === 'timeRange' ? { start: '', end: '' } : null;
    
    const newFilters = {
      ...filters,
      [type]: resetValue
    };
    
    setFilters(newFilters);
    
    // Prepare data for parent component
    const parentFilters = {
      device: newFilters.device?.value || null,
      raspberry: newFilters.raspberry?.value || null,
      status: newFilters.status?.value || null,
      date: newFilters.dateRange,
      timeStart: newFilters.timeRange.start,
      timeEnd: newFilters.timeRange.end,
    };
    
    onFilterChange(parentFilters);
  };

  const customStatusStyles = {
    option: (provided, state) => {
      const color = state.data.value === 'OK' ? 'green' : 'red';
      return {
        ...provided,
        color: color,
      };
    },
  };

  return (
    <div className="filter-container">
      <div className="filter-row">
        <Form.Group controlId="raspberrySerial" className="filter-item">
          <Form.Label>Tester Name</Form.Label>
          <Select
            options={uniqueRaspberries}
            value={filters.raspberry}
            onChange={(option) => handleFilterChange('raspberry', option)}
            isClearable
          />
          {filters.raspberry && (
            <button 
              className="btn btn-sm btn-link clear-filter-btn"
              onClick={() => handleClearFilter('raspberry')}
            >
              Clear
            </button>
          )}
        </Form.Group>

        <Form.Group controlId="statusFilter" className="filter-item">
          <Form.Label>Status</Form.Label>
          <Select
            options={statusOptions}
            value={filters.status}
            onChange={(option) => handleFilterChange('status', option)}
            isClearable
            styles={customStatusStyles}
          />
          {filters.status && (
            <button 
              className="btn btn-sm btn-link clear-filter-btn"
              onClick={() => handleClearFilter('status')}
            >
              Clear
            </button>
          )}
        </Form.Group>

        <Form.Group controlId="dateRange" className="filter-item">
          <Form.Label>Date Range</Form.Label>
          <div>
            <button 
              className="btn btn-primary calendar-btn"
              onClick={() => setShowCalendar(!showCalendar)}
            >
              {showCalendar ? 'Hide' : 'Select Dates'}
            </button>
            {(filters.dateRange[0] || filters.dateRange[1]) && (
              <button 
                className="btn btn-sm btn-link clear-filter-btn"
                onClick={() => handleClearFilter('dateRange')}
              >
                Clear
              </button>
            )}
            {showCalendar && (
              <Calendar
                selectRange
                value={filters.dateRange}
                onChange={(dates) => handleFilterChange('dateRange', dates)}
                className="calendar-popup"
              />
            )}
          </div>
        </Form.Group>
      </div>
    </div>
  );
};

export default Filter;